import { module } from 'modujs';
import { isDebug } from '../utils/environment';

/**
 * Module: Form
 *
 * When using Contact Form 7 (WPCF7), the `data-module-form` attribute
 * is expected to be on `div.wpcf7` rather than `form.wpcf7-form`.
 *
 * Similarly, Contact Form 7 and add-ons don't support XHR-based page
 * transitions, so we need to check if form has been initialized and
 * boot it if not.
 */
export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: 'onFormChange',
            reset: 'onFormReset'
        }

        if (window.wpcf7) {
            Object.assign(this.events, {
                wpcf7beforesubmit: 'onFormBeforeSubmit',
                wpcf7submit: 'onFormAfterSubmit'
            });
        }
    }

    init() {

        this.form = this.el.querySelector('form');
        this.active = false;
        this.attempt = 0;
        this.poller = null;

        if (this.isReady()) {
            this.initForm();
        } else {
            this.poller = window.setInterval(() => {
                this.attempt++;

                if (this.attempt === 50) {
                    isDebug && console.warn('[Form.init] WPCF7 is unavailable');
                    clearInterval(this.poller);
                    this.active = false;
                    return;
                }

                if (this.isReady()) {
                    this.active = true;
                    clearInterval(this.poller);
                    this.initForm();
                }
            }, 100);
        }
    }

    initForm() {
        if (!this.isReady()) {
            isDebug && console.warn('[Form.initForm] WPCF7 is unavailable');
            return;
        }

        if (!this.form.dataset.wpcf7 && !this.form.querySelector('.ajax-loader')) {

            const $form = window.jQuery(this.form);
            
            
            window.wpcf7.initForm($form);

            if (window.jQuery && window.wpcf7cf) {
                window.wpcf7cf.initForm($form);
            }
        }
    }

    /**
     * @return {bool}
     */
    isReady() {

        return (window.jQuery && window.wpcf7);
    }

    /**
     * @param  {HTMLInputElement} input - A form control element.
     * @return {void}
     */
    updateInputFileLabel(input) {
        let label = this.el.querySelector('.c-form_value[for="' + input.id + '"]');
        if (label) {
            if (!label.hasAttribute('data-initial-text')) {
                label.setAttribute('data-initial-text', label.innerText);
            }

            let value = input.value.replace('C:\\fakepath\\', '');
            label.innerText = value || label.getAttribute('data-initial-text');
        }
    }

    onFormChange(event) {
        if (event.target.type === 'file') {
            this.updateInputFileLabel(event.target);
        }
    }

    onFormReset(event) {
        this.form.querySelectorAll('[type="file"]').forEach((input) => this.updateInputFileLabel(input));
    }

    onFormBeforeSubmit(event) {
        const wpcf7 = window.wpcf7;
        if (wpcf7) {
            wpcf7.setStatus(this.form, 'busy');
            wpcf7.toggleSubmit(this.form, false);
        }
    }

    onFormAfterSubmit(event) {
        const wpcf7 = window.wpcf7;

        if (wpcf7) {
            wpcf7.toggleSubmit(this.form);
        }
    }

}